import { SyntheticEvent, useCallback, useEffect, useRef } from 'react';

import type { MenuTargetItemState } from './useMenuTargetItemState';

type Item = {
  id: number;
};

export default function useMenuTargetItemHandling<T extends Item>(
  targetState: MenuTargetItemState,
  items: Array<T>,
  defaultState?: number | null, // выбранный id по умолчанию, должен быть в items
) {
  const [, , sellPointsCurrentChange] = targetState;
  const itemsOnceLoaded = useRef(false);

  const handleRadioButtonChange = useCallback((e: SyntheticEvent<HTMLInputElement>) => {
    const { value } = e.currentTarget;
    sellPointsCurrentChange({ id: parseInt(value, 10), single: false });
  }, [sellPointsCurrentChange]);

  // обновление выбранного id при смене состояния
  useEffect(() => {
    // подразумевается что defaultState (id) есть в items
    const id: number | null = (defaultState && !itemsOnceLoaded.current
      ? defaultState
      : (items[0]?.id ?? null)
    ) || null;

    if (items.length > 0) {
      itemsOnceLoaded.current = true;
    }

    sellPointsCurrentChange({
      id,
      single: id ? items.length === 1 : true,
    });
  }, [items]); // eslint-disable-line react-hooks/exhaustive-deps

  return handleRadioButtonChange;
}
